import React, { useState } from "react";
import ManageAgentsComponent from "./manageAgents.component";
import { Spin } from "antd";

const ManageAgentsContainer = () => {
  const [loading, setLoading] = useState(false);
  return (
    <Spin spinning={loading}>
      <ManageAgentsComponent setLoading={setLoading} />
    </Spin>
  );
};

export default ManageAgentsContainer;
